import {ACCENT_COLORS, ACCENT_FILL} from "../lib/color";
import {Typography, type TypographyProps} from "../Typography";

export const TAG_COLORS = [...ACCENT_COLORS, "neutral"] as const;

export type TagColor = typeof TAG_COLORS[number];

export type TagProps =
	Omit<
		TypographyProps,
		"variant" | "component" | "color" | "align" | "isTruncated" | "noWrap" | "className"
	>
	& {color?: TagColor};

export const Tag = ({color = "neutral", children, ...props}: TagProps) =>
	<Typography
		{...props}
		component="span"
		variant="tag2"
		color="white"
		noWrap
		data-component="Tag"
		className={`${baseStyles} ${colorStyles[color]}`}>
		{children}
	</Typography>;

Tag.displayName = "Tag";

const baseStyles =
	"inline-flex h-[21px] w-fit shrink-0 items-center justify-center gap-1 " +
	"rounded-2xl border px-3 [&_svg]:size-3 [&_svg]:shrink-0";

const colorStyles: Record<TagColor, string> = {
	...ACCENT_FILL,
	neutral: "border-foreground-100 bg-transparent"
};
